import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { X, Plus, Star } from "lucide-react";
import { ContactFormDialog } from "@/components/inquiries/ContactFormDialog";

export const ContactPicker = ({ value, onChange, primary, onPrimary }) => {
  const [all, setAll] = useState([]);
  const [q, setQ] = useState("");
  const [adding, setAdding] = useState(false);
  useEffect(() => { api.get("/contacts").then((r) => setAll(r.data)).catch(() => {}); }, []);
  const byId = Object.fromEntries(all.map((c) => [c.id, c]));
  const matches = q.trim() ? all.filter((c) => !value.includes(c.id) && `${c.name} ${c.organisation || ""} ${c.email || ""}`.toLowerCase().includes(q.toLowerCase())).slice(0, 6) : [];
  const add = (id) => { onChange([...value, id]); if (!primary) onPrimary?.(id); setQ(""); };
  return (
    <div data-testid="contact-picker">
      <div className="flex flex-wrap gap-1.5 mb-2">
        {value.map((id) => (
          <span key={id} data-testid={`picked-contact-${id}`} className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full border border-blue-200 bg-blue-50 text-blue-900">
            <button type="button" title="Primary contact" onClick={() => onPrimary?.(id)}><Star className={`w-3 h-3 ${primary === id ? "fill-amber-400 text-amber-500" : "text-blue-300"}`} /></button>
            {byId[id]?.name || "…"}{byId[id]?.organisation ? <span className="text-blue-500">· {byId[id].organisation}</span> : null}
            <button type="button" data-testid={`unpick-contact-${id}`} onClick={() => onChange(value.filter((x) => x !== id))}><X className="w-3 h-3" /></button>
          </span>
        ))}
      </div>
      <div className="relative flex gap-2">
        <Input data-testid="contact-search" value={q} placeholder="Search contacts by name, organisation or email" onChange={(e) => setQ(e.target.value)} className="h-9" />
        <Button type="button" variant="outline" size="sm" data-testid="contact-new-inline" onClick={() => setAdding(true)} className="gap-1 h-9"><Plus className="w-3.5 h-3.5" />New</Button>
        {matches.length > 0 && (
          <div className="absolute top-10 left-0 right-24 z-50 bg-white border border-slate-200 rounded-md shadow-lg">
            {matches.map((c) => (
              <button type="button" key={c.id} data-testid={`contact-option-${c.id}`} onClick={() => add(c.id)} className="block w-full text-left px-3 py-2 text-sm hover:bg-blue-50">
                {c.name} <span className="text-xs text-slate-500">{[c.organisation, c.email].filter(Boolean).join(" · ")}</span>
              </button>
            ))}
          </div>
        )}
      </div>
      <ContactFormDialog open={adding} onClose={() => setAdding(false)} onSaved={(c) => { setAll((l) => [...l, c]); add(c.id); setAdding(false); }} />
    </div>
  );
};
